/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter, useParams, useHistory } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Form from "./Form";
import VisitorsContext from "./VisitorsContext";
import { getDateMillis } from "utils/dateUtils";
import Header from "components/common_components/Header"

function Visitor(props) {
    const history = useHistory();
    const { id } = useParams();
    const [visitor, setVisitor] = useState(undefined);
    const [resources, setResources] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { mode } = props;

    const Visitors = useContext(VisitorsContext);

    function getVisitor() {
        setIsLoading(true);
        Visitors.getOneById({
            id,
            onSuccess: (data) => {
                setVisitor(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    function getResources() {
        Visitors.getResources({
            onSuccess: (data) => {
                setResources(data);
            },
            onError: (error) => {
                setResources(undefined);
                dispatch(notifyError(error));
            },
        });
    }

    useEffect(() => {
        if (id) {
            getVisitor();
        }
    }, [id]);

    useEffect(() => {
        getResources();
    }, []);

    function onEditHandler() {
        history.push(`/visitors/${id}/update`);
    }

    function onCancelHandler() {
        history.goBack();
    }

    function onSuccess(_, setSubmitting) {
        setSubmitting(false);
        dispatch(notifySuccess(`Visitor ${mode === "add" ? "created" : "updated"} successfully!`));
        onCancelHandler();
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    async function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { ssn, dob, visitDate, country: fullCountry, ...payload } = values;

        const dobInMillis = getDateMillis(dob);
        const visitDateInMillis = getDateMillis(visitDate);

        const apiCall = mode === "add" ? Visitors.add : Visitors.update;

        apiCall({
            payload: {
                id: mode === "update" ? id : null,
                ...payload,
                dob: dobInMillis,
                visitDate: visitDateInMillis,
                ssn: ssn.trim().toLowerCase(),
                country: fullCountry ? fullCountry.code : null,
            },
            onSuccess: (response) => onSuccess(response, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    return (
        <Page>
            <Header title="Visitor" />
            {isLoading && <LoadingPage />}
            {!isLoading && (
                <Form
                    visitor={visitor}
                    resources={resources}
                    {...props}
                    onCancel={onCancelHandler}
                    onSubmit={onSubmitHandler}
                    onEdit={onEditHandler}
                />
            )}
        </Page>
    );
}

Visitor.propTypes = {
    mode: PropTypes.oneOf(["add", "detail", "update"]).isRequired,
    title: PropTypes.string,
};

export default withRouter(Visitor);
